import Stack from './Stack'

export default Stack
// eslint-disable-next-line import/export
export * from './Stack'
